module.exports = __webpack_public_path__ + "static/media/umu_logo.f3fdbc66.svg";